import logo_src from "../../../image/logo_dark.svg";
import page_dashboard_background from "../page/PageDashboard/image/background.png";

export default {
  colorPrimary: "#274C5B",
  fontFamily: "Inter, sans-serif",

  logo_src,
  page_builder__background: `url(${page_dashboard_background}) #eef1f3 no-repeat`,
  page_dashboard__background: "#EDEFEF",
  page_dashboard__hero_background: `url(${page_dashboard_background}) #eef1f3 no-repeat`,
  page_dashboard__card_quick_start_background: "#647479",
  page_dashboard__card_quick_start_background_hover: "#3f6979",
  sidebar__width: 200,

  advisor_page_dashboard_active_tab_color: "#DBE247",
  advisor_page_dashboard_show_sections_news: true,
  chart_gauge__color_primary: "#559CF3",
  chart_gauge__color_empty: "#D7D8D8",
  quarterly_goal_aum_color: "#DBE247",
  quarterly_goal_client_color: "#4F8083",
  quarterly_goal_proposal_color: "#749B9E",
  radio_button_color: "#4F8083",
  sidebar_avatar_background: "#6DC1C7",
  sidebar_avatar_color: "#FFFFFF",
  sidebar_background: "#fff",
  sidebar_profile_color: "#274C5B",
  top_products_pie_chart_pallet: ["#296469", "#DBE247", "#03494E", "#749B9E"],
};
